/* Search */
export default (el) => {
    const url = 'https://apps.ticketmatic.com/widgets/plugin/dewerf/basket';

    let xhr = new XMLHttpRequest();
    xhr.addEventListener('load', function () {
        var status = xhr.status;
        if (status === 200) {
            var response = xhr.response;
            var total = parseInt(response.nbroftickets);
            if (total > 0) {
                el.classList.remove('-hidden');
                el.innerHTML = response.nbroftickets;
            }
        }
    });
    xhr.open('GET', url);
    xhr.responseType = 'json';
    xhr.withCredentials = true;
    xhr.send();
};
